import { useState } from 'react';
import { MainLayout } from "../../layout/MainLayout";
import { TablePaginationProvider } from "../../components/TablePagination/context";
import { SubnetworksTree } from "../../components/SubnetworksTree";
import Switch from '@mui/material/Switch';
import Typography from "@mui/material/Typography";
import { AdministratorsTree } from "../../components/AdministratorsTree";
import useAuth from "../../routes/login/AuthContext";

export const NetworkSettingsPage = () => {
  const { isSuperAdmin } = useAuth();
  const [ showArchived, setShowArchived ] = useState<boolean>(false);
  const handleTogglChange = (_: any, checked: boolean) =>setShowArchived(checked);
  
  return (
    <MainLayout
      title="Unit Types"
      endAdornment={<>
        <Typography> Show Archived
          <Switch value={showArchived} onChange={handleTogglChange}/>
        </Typography>
        </>
      }
    >
      <TablePaginationProvider>
        <SubnetworksTree isPreview expandAsDefault showArchived={showArchived}/>
        {isSuperAdmin() ? <AdministratorsTree /> : null}
      </TablePaginationProvider>
    </MainLayout>
  );
};
